var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view your",attrs:{"data-name":"your"}},[_c('RailsContent',{attrs:{"data":_vm.instagram,"is-medium":false}}),_c('PageHero',{attrs:{"title":'Your.',"text":''}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }